import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

export function useHeaderCounters() {
  const counters = computed(() => usePage().props.header.counters)

  const incrementCounter = (counterName) => {
    counters.value[counterName]++
  }

  const decrementCounter = (counterName, count = 1) => {
    counters.value[counterName] = counters.value[counterName] - count
  }

  const counter = (counterName) => {
    return counters.value[counterName]
  }

  return {
    incrementCounter,
    decrementCounter,
    counter,
  }
}
